
import React, { useEffect, useState } from "react";
import { Menu, Transition } from "@headlessui/react";
import { Fragment } from "react";
import { FiLogOut, FiUser, FiBell, FiSearch, FiSettings, FiLock } from "react-icons/fi";
import { MdOutlineLightMode, MdOutlineDarkMode } from "react-icons/md";
import { useNavigate } from "react-router-dom"; // Added useNavigate

export default function Navbar({ darkMode, setDarkMode }) {
  const [role, setRole] = useState("");
  const [notifications, setNotifications] = useState(3);
  const navigate = useNavigate(); // Added navigate hook

  useEffect(() => {
    const storedRole = localStorage.getItem("role");
    if (storedRole) {
      setRole(storedRole);
    }
  }, []);

  return (
    <div className="bg-white dark:bg-gray-900 h-16 px-6 flex items-center border-b border-gray-200 dark:border-gray-800 justify-between w-full shadow-sm">
      
      {/* Search Bar
      <div className="flex-1 max-w-md">
        <div className="relative">
          <FiSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 text-lg" />
          <input
            type="text"
            placeholder="Search..."
            className="w-full pl-10 pr-4 py-2 bg-gray-100 dark:bg-gray-800 border-0 rounded-xl focus:ring-2 focus:ring-blue-500 focus:bg-white dark:focus:bg-gray-700 transition text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400"
          />
        </div>
      </div> */}

      {/* Right Side Controls */}
      <div className="flex items-center gap-4">
        
        {/* Theme Toggle */}
        <button
          onClick={() => setDarkMode(!darkMode)}
          className="p-2 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-xl transition text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white relative"
          title={darkMode ? "Light Mode" : "Dark Mode"}
        >
          {/* {darkMode ? (
            <MdOutlineLightMode className="text-xl" />
          ) : (
            <MdOutlineDarkMode className="text-xl" />
          )} */}
          {darkMode ? (
  <MdOutlineDarkMode className="text-xl" />
) : (
  <MdOutlineLightMode className="text-xl" />
)}

        </button>

        {/* Notifications */}
        {/* <Menu as="div" className="relative">
          <Menu.Button className="p-2 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-xl transition text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white relative">
            <FiBell className="text-xl" />
            {notifications > 0 && (
              <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
                {notifications}
              </span>
            )}
          </Menu.Button>
          <Transition
            as={Fragment}
            enter="transition ease-out duration-200"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-150"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items className="absolute right-0 mt-2 w-80 origin-top-right bg-white dark:bg-gray-800 divide-y divide-gray-100 dark:divide-gray-700 rounded-xl shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-50">
              <div className="px-4 py-3">
                <p className="text-sm font-medium text-gray-900 dark:text-white">
                  Notifications
                </p>
              </div>
              <div className="py-2">
                <Menu.Item>
                  <div className="px-4 py-3 hover:bg-gray-50 dark:hover:bg-gray-700 cursor-pointer">
                    <p className="text-sm text-gray-900 dark:text-white">
                      New task assigned
                    </p>
                    <p className="text-xs text-gray-500 dark:text-gray-400">
                      2 minutes ago
                    </p>
                  </div>
                </Menu.Item>
              </div>
            </Menu.Items>
          </Transition>
        </Menu> */}

        {/* Settings */}
        {/* <button className="p-2 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-xl transition text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white">
          <FiSettings className="text-xl" />
        </button> */}

        {/* User Profile */}
        <Menu as="div" className="relative">
          <div className="flex items-center gap-3">
            <div className="text-right hidden md:block">
              <p className="text-sm font-medium text-gray-900 dark:text-white">
                {role ? role : "Guest"}
              </p>
              <p className="text-xs text-gray-500 dark:text-gray-400">
                Administrator
              </p>
            </div>
            <Menu.Button className="flex items-center gap-2 hover:ring-2 hover:ring-blue-500 rounded-full p-1 transition-all duration-200 focus:outline-none">
              <div
                className="h-10 w-10 rounded-full bg-gradient-to-r from-blue-500 to-cyan-500 border-2 border-white dark:border-gray-800 bg-cover bg-no-repeat bg-center shadow-lg hover:scale-105 transition-transform"
                style={{
                  backgroundImage:
                    'url("https://i.pinimg.com/474x/67/c3/d6/67c3d63e215e034e01d45c8256d720d3.jpg")',
                }}
              />
            </Menu.Button>
          </div>

          <Transition
            as={Fragment}
            enter="transition ease-out duration-200"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-150"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items className="absolute right-0 mt-2 w-56 origin-top-right bg-white dark:bg-gray-800 divide-y divide-gray-100 dark:divide-gray-700 rounded-xl shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-50">
              
              <div className="px-4 py-3">
                <p className="text-sm text-gray-700 dark:text-gray-300">Signed in as</p>
                <p className="text-sm font-medium text-gray-900 dark:text-white truncate">
                  {role ? role : "Guest"}
                </p>
              </div>

              <div className="py-2">
                {/* <Menu.Item>
                  {({ active }) => (
                    <button
                      className={`${
                        active ? "bg-gray-100 dark:bg-gray-700" : ""
                      } flex items-center gap-2 w-full px-4 py-2 text-sm text-gray-700 dark:text-gray-300`}
                    >
                      <FiUser /> 
                      Profile Settings
                    </button>
                  )}
                </Menu.Item> */}
                {/* Reset Password Menu Item - Now navigates to separate page */}
                <Menu.Item>
                  {({ active }) => (
                    <button
                      className={`${
                        active ? "bg-gray-100 dark:bg-gray-700" : ""
                      } flex items-center gap-2 w-full px-4 py-2 text-sm text-gray-700 dark:text-gray-300`}
                      onClick={() => navigate("reset-password")} // Navigate to separate page
                    >
                      <FiLock />
                      Reset Password
                    </button>
                  )}
                </Menu.Item>
                <Menu.Item>
                  {({ active }) => (
                    <button
                      className={`${
                        active ? "bg-gray-100 dark:bg-gray-700" : ""
                      } flex items-center gap-2 w-full px-4 py-2 text-sm text-gray-700 dark:text-gray-300`}
                      onClick={() => setDarkMode(!darkMode)}
                    >
                      {darkMode ? <MdOutlineLightMode /> : <MdOutlineDarkMode />}
                      {darkMode ? "Light Mode" : "Dark Mode"}
                    </button>
                  )}
                </Menu.Item>
              </div>

              <div className="py-2">
                <Menu.Item>
                  {({ active }) => (
                    <button
                      className={`${
                        active ? "bg-red-50 dark:bg-red-900/20" : ""
                      } flex items-center gap-2 w-full px-4 py-2 text-sm text-red-600 dark:text-red-400`}
                      onClick={() => {
                        localStorage.clear();
                        window.location.href = "/";
                      }}
                    >
                      <FiLogOut /> 
                      Logout
                    </button>
                  )}
                </Menu.Item>
              </div>
              
            </Menu.Items>
          </Transition>
        </Menu>
      </div>
    </div>
  );
}